import React, { useEffect, useState } from 'react'
import { Modal, TimePicker, Switch, Select, Icon, Form, Input, DatePicker, Spin, Card, Row, Col, Tabs, Table, Button, Radio, message, notification } from 'antd'
import { queryRootAgency, queryAgencyByPid, queryClinicList, queryClinicEmployee, getAllReservation } from '@/services/basicinfo'
import { orderReservations, customerOrderReservations, checkReserveClash, getReservedTimes } from '@/services/order'
import { getRoomList } from '@/services/room'
import { CLINIC_KEY } from '@/utils/consts'
import moment from 'moment'
import CustomerPicker from '@/components/CustomerPicker'
import styles from './index.less'
import TextArea from 'antd/lib/input/TextArea'
import { cloneDeep, isFunction, get as SafeGet, isUndefined } from 'lodash'
const { TabPane } = Tabs
const { Option, OptGroup } = Select
const formItemLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 14,
  },
}

const FORMAT = 'HH:mm'
const MINUTE_STEP = 10
const MINUTE_OPTIONS = []
for (let i = 0; i < 60; i += MINUTE_STEP) {
  MINUTE_OPTIONS.push(i)
}
let orderReserveTimer = null
const reserveStatus = [
  { value: 'to_be_confirm', key: '待确认' },
  { value: 'success', key: '预约成功' },
  { value: 'arrival', key: '到店' },
  { value: 'cancel', key: '取消' },
]

const OrderReserveModal = ({ data, types, title, source, nickname, clinicId, btnLoading, onCancel, form, onOk, onBatchOk, createOrder, frequentEmployee, ...modalProps }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue, validateFields } = form
  const [agencyTree, setAgencyTree] = useState([])
  const [datasTow, setDatasTow] = useState([])
  const [datasTowClone, setDatasTowClone] = useState([])
  const [member, setMember] = useState([])
  const [roomList, setRoomList] = useState([])
  const [disabled, setDisabled] = useState(false)
  const [reservationItems, setReservationItems] = useState([])
  const [orderItemVos, setOrderItemVos] = useState([])
  const [overReservation, setOverReservation] = useState([]) // 所有已完成预约
  const [batchSetList, setBatchSetList] = useState([{ date: null, reservationStatus: 'to_be_confirm', selectedRowKeys: [], comment: '' }])
  const [disableRow, setDisableRow] = useState({ 0: [] }) // 不能选择的列表
  const [expandedKeys, setExpandedKeys] = useState([])

  const datas2 = data.reservationItemResps || []
  const { executor } = frequentEmployee
  useEffect(() => {
    setDatasTow([...datas2])
    setDatasTowClone([...datas2])
    queryClinicList({}).then((res) => {
      const { code, data } = res
      if (code === 0) {
        setAgencyTree(data)
      }
    })
    if (data.orderId) {
      queryOrderReserve(data.orderId)
    }
    if (source !== 'ORDER' && data.customerId) {
      handleChangeCustomer(data.customerId, data.clinicId || clinicId)
    }
    // if(types !== 'add' && !data.reservationItemResps) {
    //     setFieldsValue({'isComeToClinic': true})
    // }
    if (data.clinicId || clinicId) {
      queryMember(data.clinicId || clinicId)
      queryRoom(data.clinicId || clinicId)
    }
  }, [clinicId])

  useEffect(() => {
    if (!clinicId) {
      queryRoom(getFieldValue('clinicId'))
    }
  }, [getFieldValue('clinicId')])

  // 获取诊所下的员工列表
  const queryMember = async (id) => {
    const { code, data } = await queryClinicEmployee({ id })
    if (code === 0 && data) {
      if (data && data.length > 0) {
        setMember([...data])
      } else {
        setMember([])
      }
    }
  }

  //获取房间列表
  const queryRoom = async (id) => {
    const { code, data } = await getRoomList({ pageNo: 1, pageSize: 10000, clinicId: id })
    if (code === 0 && data) {
      setRoomList(data.rows)
    }
  }

  // 获取订单的待预约列表
  const queryOrderReserve = async (id) => {
    let { code, data } = await orderReservations({ id })
    const res = await getAllReservation({ orderId: id, pageNo: 1, pageSize: 9999 })
    if (code === 0 && data && res.code === 0) {
      if (data && data.length > 0) {
        if (res.data && res.data.length > 0) {
          setOverReservation(res.data)
          //取上一次的时间和执行人
          data.forEach((item) => {
            item.startAt = res.data[res.data.length - 1].startAt && moment(res.data[res.data.length - 1].startAt)
            item.endAt = res.data[res.data.length - 1].endAt && moment(res.data[res.data.length - 1].endAt)
            item.employeeName = res.data[res.data.length - 1].employeeName
            item.employeeId = res.data[res.data.length - 1].employeeId
            item.userId = res.data[res.data.length - 1].userId
          })
        }
        setOrderItemVos([...data])
      } else {
        setOrderItemVos([])

      }
    }
  }

  // 去订单页
  const handleOpenOrder = (key) => {
    notification.close(key)
    let parmas = {
      clinicId: data.clinicId,
      customerId: data.customerId || getFieldValue('customerId').customerId,
      customerName: data.customerName || getFieldValue('customerId').customerName
    }
    createOrder('order', 'add', parmas)
  }

  const openNotification = () => {
    const key = `open${Date.now()}`
    const btn = (
      <div>
        <Button type='primary' size='small' onClick={() => notification.close(key)} style={{ marginRight: 10 }}>
          继续预约
        </Button>
        <Button type='primary' size='small' onClick={() => handleOpenOrder(key)}>
          确定
        </Button>
      </div>
    )
    notification.open({
      message: '提示',
      description: '该客户暂无可预约订单项, 是否需要先下订单',
      duration: null,
      btn,
      key,
      onClose: close,
    })
  }

  // 获取客户的所有待预约列表
  const handleChangeCustomer = async (id, clinicId) => {
    let datas = data
    if (id && clinicId) {
      const { code, data } = await customerOrderReservations({ id, clinicId })
      if (code === 0 && data) {
        if (data && data.length > 0) {
          setOrderItemVos([...data])

          if (types !== 'add' && !datas.reservationItemResps) {
            setFieldsValue({ isComeToClinic: true })
          } else {
            setFieldsValue({ isComeToClinic: false })
          }
        } else {
          setOrderItemVos([])
          setFieldsValue({ isComeToClinic: true })
          if (types === 'add') {
            openNotification()
          }
        }
      }
    }
  }

  const handleOk = (e) => {
    validateFields((errors, values) => {
      if (errors) {
        return
      }
      let { customerId, reservationAt, startAt, endAt, ...params } = values
      if ((source === 'ORDER' && types === 'add' && reservationItems.length === 0) || (source !== 'ORDER' && orderItemVos.length > 0 && !params.isComeToClinic && reservationItems.length === 0)) {
        message.error('请至少选择一项待预约')
        return
      }
      let reservationItem = []
      if (source === 'ORDER' || !params.isComeToClinic) {
        if (types === 'add') {
          reservationItem = [...reservationItems]
        } else {
          reservationItem = [...datasTowClone, ...reservationItems]
        }
        reservationItem.map(_ => {
          delete _.categoryList
          delete _.editable
          delete _.totalServiceCount
          delete _.room
        })
        if (!reservationItem.every(_ => _.employeeId)) {
          return message.error('请选择待预约项执行人')
        }
      }
      if (source !== 'ORDER' && params.isComeToClinic) {
        reservationItem = []
      }

      // 处理仅预约到店
      let type = 'to_clinic'
      delete params.customerName
      if (params.isComeToClinic == false || source == 'ORDER') {
        type = 'for_product'
      }

      customerId = customerId ? customerId.customerId : undefined
      if (orderReserveTimer !== null) {
        clearTimeout(orderReserveTimer)
      }
      orderReserveTimer = setTimeout(() => {
        onOk({
          id: data.id || undefined,
          type,
          orderId: source === 'ORDER' ? data.orderId : undefined,
          reservationItems: reservationItem || undefined,
          isComeToClinic: reservationItems.length ? false : true,
          reservationAt: reservationAt ? moment(reservationAt).format('YYYY-MM-DD') : undefined,
          startAt: reservationAt && startAt ? `${moment(reservationAt).format('YYYY-MM-DD')} ${moment(startAt).format(FORMAT)}:00` : undefined,
          endAt: reservationAt && endAt ? `${moment(reservationAt).format('YYYY-MM-DD')} ${moment(endAt).format(FORMAT)}:00` : undefined,
          customerId,
          ...params
        }, customerId, data.customerName)
      }, 500)
    })
  }

  const handleBatchAddReserve = (wrapIdx) => {
    validateFields((errors, values) => {
      if (errors) return null
      let { customerId, ...rest } = values
      customerId = customerId ? customerId.customerId : undefined
      if (isUndefined(wrapIdx)) {  // 批量预约
        // ...
      } else {  // 单个预约
        const newBatchSetList = cloneDeep(batchSetList)
        newBatchSetList[wrapIdx].spinning = true // 增加spinning
        const current = batchSetList[wrapIdx]
        const { date, selectedRowKeys, reservationStatus, comment } = current
        if (!date || selectedRowKeys.length === 0 || !reservationStatus) {
          return message.error('没填预约日期或者没勾选商品')
        }
        if (selectedRowKeys) {
          let selectList = orderItemVos.filter(i => selectedRowKeys.includes(i.id))
          selectList = selectList.map(item => {
            return {
              ...item,
              startAt: moment(`${moment(date).format('YYYY-MM-DD')} ${moment(item.startAt).format(FORMAT)}:00`),
              endAt: moment(`${moment(date).format('YYYY-MM-DD')} ${moment(item.endAt).format(FORMAT)}:00`),
            }
          })
          const firstItem = SafeGet(selectList, '0')
          const wrapStartAt = SafeGet(selectList, '0.startAt')
          const wrapEndAt = SafeGet(selectList, `${selectList.length - 1}.endAt`)
          if (wrapStartAt && wrapEndAt && wrapEndAt.isBefore(wrapStartAt)) {
            return message.error('结束时间不能早于开始时间')
          }

          if (!selectList.every(_ => _.employeeId)) {
            return message.error('请选择待预约项执行人')
          }

          const parmas = {
            ...rest,
            isComeToClinic: false,
            startAt: wrapStartAt ? `${moment(date).format('YYYY-MM-DD')} ${moment(wrapStartAt).format(FORMAT)}:00` : void (0),
            endAt: wrapEndAt ? `${moment(date).format('YYYY-MM-DD')} ${moment(wrapEndAt).format(FORMAT)}:00` : void (0),
            status: reservationStatus,
            comment,
            reservationAt: moment(date).format('YYYY-MM-DD'),
            customerId: customerId,
            orderId: data.orderId,
            type: 'for_product',
            reservationItems: selectList,
          }
          if (parmas.startAt && parmas.endAt) {
            // 检查冲突
            checkReserveClash({ clinicId: parmas.clinicId, startAt: parmas.startAt, endAt: parmas.endAt, executorId: firstItem.userId })
              .then(({ code, data }) => {
                if (code === 0) {
                  if (data && data.length > 0) {
                    Modal.confirm({
                      icon: null,
                      title: '预约时间冲突提醒',
                      okText: '继续预约',
                      cancelText: '取消',
                      width: 550,
                      content: <div>
                        <p>以下是预约冲突时间</p>
                        {
                          data.map((item, idx) => {
                            return <div key={idx}>
                              <span style={{ width: '25%', color: 'red', display: 'inline-block' }}>{item.productName}</span>
                              <span style={{ width: '10%', color: 'red', display: 'inline-block' }}>{item.employeeName}</span>
                              <span style={{ width: '10%', color: 'red', display: 'inline-block' }}>{item.customerName}</span>
                              <span style={{ width: '55%', color: 'red', display: 'inline-block' }}>{moment(item.startAt).format('YYYY-MM-DD HH:mm')}~{moment(item.endAt).format('YYYY-MM-DD HH:mm')}</span>
                            </div>
                          })
                        }
                      </div>,
                      onOk() {
                        setBatchSetList(newBatchSetList)
                        isFunction(onBatchOk) && onBatchOk(parmas, customerId, data.customerName)
                      },
                    })
                  } else {
                    setBatchSetList(newBatchSetList)
                    isFunction(onBatchOk) && onBatchOk(parmas, customerId, data.customerName)
                  }
                }
              })
          } else {
            return message.error('没填预约日期')
          }
        }
      }
    })
  }

  const disableEndHourTableStart = () => {
    const startTime = getFieldValue('startAt')
    const entTime = getFieldValue('endAt')
    if (!startTime) return []
    const hour = startTime.get('hour')
    const hourEnd = entTime.get('hour')
    const disabledHours = []
    for (let i = 0; i < hour; i++) {
      disabledHours.push(i)
    }
    for (let i = hourEnd + 1; i < 24; i++) {
      disabledHours.push(i)
    }
    return disabledHours
  }

  const disableEndMinuteStart = (selectedHour) => {
    const startTime = getFieldValue('startAt')
    const entTime = getFieldValue('endAt')
    if (!startTime) return []
    const hour = startTime.get('hour')
    const hourEnd = entTime.get('hour')
    const minute = startTime.get('minute')
    const minuteEnd = entTime.get('minute')
    if (hour > selectedHour && hourEnd < selectedHour) return MINUTE_OPTIONS
    if (hour === selectedHour) {
      return MINUTE_OPTIONS.filter(_ => _ < minute)
    }
    if (hourEnd === selectedHour) {
      return MINUTE_OPTIONS.filter(_ => _ > minute)
    }
    return []
  }

  const columns = (wrapIdx) => {

    return [
      {
        dataIndex: 'id',
        title: '明细编号',
        width: 60,
      },
      {
        dataIndex: 'productCategoryName',
        title: '商品类别',
        width: 140,
        ellipsis: true,
        render: (_, record) => (record.categoryList || []).map(_ => _.name).join('/')
      },
      {
        dataIndex: 'productName',
        title: '商品名称',
        ellipsis: true,
        width: 120,
      },
      {
        dataIndex: 'member',
        title: '执行人',
        width: 120,
        align: 'center',
        render(text, record, index) {
          return <Select
            showSearch
            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
            style={{ width: 100 }}
            onChange={e => handleChangeReservationItems(record.id, 'employee', e, wrapIdx)}
            value={record.employeeId}
          >
            <OptGroup label='常用人选'>
              {
                executor.map(i => {
                  return <Option value={i.id}>{i.name}</Option>
                })
              }
            </OptGroup>
            {member && member.map(item => <Option value={item.id} key={item.id}>{item.name}</Option>)}
          </Select>
        }
      },
      {
        dataIndex: 'time',
        title: '预约时间',
        width: 240,
        align: 'center',
        render(text, record, index) {
          return <span>
            <TimePicker
              style={{ width: 90 }}
              placeholder='开始时间'
              format={FORMAT}
              defaultOpenValue={moment('09:00', 'HH:mm')}
              minuteStep={MINUTE_STEP}
              onChange={e => handleChangeReservationItems(record.id, 'startAt', e, wrapIdx, index)}
              value={record.startAt ? moment(record.startAt) : null}
            />
            ~
            <TimePicker
              style={{ width: 90 }}
              placeholder='结束时间'
              format={FORMAT}
              defaultOpenValue={moment('09:00', 'HH:mm')}
              minuteStep={MINUTE_STEP}
              onChange={e => handleChangeReservationItems(record.id, 'endAt', e, wrapIdx, index)}
              value={record.endAt ? moment(record.endAt) : null}
            />
          </span>
        }
      },
      {
        dataIndex: 'roomId',
        title: '执行房间',
        width: 120,
        render: (text, record, index) => {
          return <Select
            style={{ width: 100 }}
            onChange={e => handleChangeReservationItemsByRoom(record.id, 'employee', e)}
            value={record.roomId}
          >
            {roomList && roomList.map(item => <Option value={item.id} key={item.id}>{item.shortName}</Option>)}
          </Select>
        }
      },
      {
        dataIndex: 'orderCode',
        title: '订单编号',
        width: 80,
        ellipsis: true,
      },
    ]
  }

  const handleChangeReservationItems = async (id, key, e, wrapIdx) => {
    const index = orderItemVos.findIndex(i => i.id == id)
    let employees = member.filter(_ => _.id === e)[0]
    let orderItem = orderItemVos
    let selectedRowsCl = reservationItems
    if (key === 'employee') {
      const clinicId = localStorage.getItem(CLINIC_KEY)
      const reservationAt = SafeGet(batchSetList, `${wrapIdx}.date`)
      if (!reservationAt) {
        return message.error('请先选择预约到店日期')
      }
      orderItem[index].employeeId = employees.id
      orderItem[index].employeeName = employees.name
      orderItem[index].userId = employees.userId
      selectedRowsCl.map((_, el) => {
        if (_.id === orderItem[index].id) {
          selectedRowsCl[el].employeeId = employees.id
          selectedRowsCl[el].employeeName = employees.name
          selectedRowsCl[el].userId = employees.userId
        }
      })
      // 获取当前不可预约时间
      const { data } = await getReservedTimes({ clinicId, date: moment(reservationAt).format('YYYY-MM-DD'), executorId: employees.userId })
      const reservedTimesString = data.map(slot => `${slot.startAt}-${slot.endAt}`).join(',')
      orderItem[index].reservedTimesString = reservedTimesString
    } else {
      const reservationAt = SafeGet(batchSetList, `${wrapIdx}.date`)
      if (!reservationAt) {
        return message.error('请先选择预约到店日期')
      }
      orderItem[index][key] = e ? moment(`${moment(reservationAt).format('YYYY-MM-DD')} ${moment(e).format(FORMAT)}:00`) : undefined
      if (key == 'startAt') {
        orderItem[index]['endAt'] = e ? moment(`${moment(reservationAt).format('YYYY-MM-DD')} ${moment(e).add(1, 'h').format(FORMAT)}:00`) : undefined
      }
      selectedRowsCl.map((_, el) => {
        if (_.id === orderItem[index].id) {
          selectedRowsCl[el][key] = e ? moment(`${moment(reservationAt).format('YYYY-MM-DD')} ${moment(e).format(FORMAT)}:00`) : undefined
        }
      })
    }
    if ((key == 'startAt' || key == 'endAt') && index === 0 && e) {
      const reservationAt = SafeGet(batchSetList, `${wrapIdx}.date`)
      let startAt = undefined
      let endAt = undefined
      if (key == 'startAt') {
        startAt = moment(`${moment(reservationAt).format('YYYY-MM-DD')} ${moment(e).format(FORMAT)}:00`)
        endAt = moment(`${moment(reservationAt).format('YYYY-MM-DD')} ${moment(e).add(1, 'h').format(FORMAT)}:00`)
      }
      if (key == 'endAt') {
        startAt = orderItem[index]['startAt']
        endAt = moment(`${moment(reservationAt).format('YYYY-MM-DD')} ${moment(e).format(FORMAT)}:00`)
      }
      orderItem = orderItem.map(i => {
        return {
          ...i,
          startAt,
          endAt,
        }
      })
    }
    setOrderItemVos([...orderItem])
    setReservationItems([...selectedRowsCl])
  }

  useEffect(() => {
    setExpandedKeys(orderItemVos.map(item => item.id))
  }, [orderItemVos])

  const handleChangeReservationItemsByRoom = (id, key, e) => {
    const index = orderItemVos.findIndex(i => i.id == id)
    let room = roomList.filter(_ => _.id === e)[0]
    let orderItem = orderItemVos
    let selectedRowsCl = reservationItems
    orderItem[index].roomId = room.id
    selectedRowsCl.map((_, el) => {
      if (_.id === orderItem[index].id) {
        selectedRowsCl[el].roomId = room.id
      }
    })
    setOrderItemVos([...orderItem])
    setReservationItems([...selectedRowsCl])
  }

  const columns2 = [
    {
      dataIndex: 'orderCode',
      title: '订单号',
      width: 280,
    },
    {
      dataIndex: 'productCategoryName',
      title: '商品类别',
      width: 140,
      ellipsis: true,
      render: (_, record) => (record.categoryList || []).map(_ => _.name).join('/')
    },
    {
      dataIndex: 'productName',
      title: '商品名称',
      width: 120,
    },
    {
      dataIndex: 'employeeName',
      title: '执行人',
      width: 100,
      align: 'center',
      render(text, record, index) {
        if (record.editable) {
          return <Select style={{ width: 100 }} value={datasTowClone[index].employeeId} onChange={(e) => {
            let newData = datasTowClone
            let employees = member.filter(_ => _.id === e)[0]
            newData[index].employeeId = employees.id
            newData[index].employeeName = employees.name
            newData[index].userId = employees.userId
            setDatasTowClone([...newData])
          }} >
            {member && member.map(item => <Option value={item.id} key={item.id}>{item.name}</Option>)}
          </Select>
        } else {
          return <span>{text}</span>
        }
      }
    },
    {
      dataIndex: 'startAt',
      title: '预约时间',
      width: 240,
      align: 'center',
      render(text, record, index) {
        if (record.editable) {
          return <span>
            <TimePicker
              style={{ width: 90 }}
              placeholder='开始时间'
              format={FORMAT}
              value={datasTowClone[index].startAt ? moment(datasTowClone[index].startAt) : null}
              minuteStep={MINUTE_STEP}
              disabledHours={() => disableEndHourTableStart()}
              disabledMinutes={(date) => disableEndMinuteStart(date)}
              onChange={e => {
                let newData = datasTowClone
                const reservationAt = getFieldValue('reservationAt')
                newData[index].startAt = e ? moment(`${moment(reservationAt).format('YYYY-MM-DD')} ${moment(e).format(FORMAT)}:00`) : null
                setDatasTowClone([...newData])
              }} />
            ~
            <TimePicker
              style={{ width: 90 }}
              placeholder='结束时间'
              format={FORMAT}
              value={datasTowClone[index].endAt ? moment(datasTowClone[index].endAt) : null}
              minuteStep={MINUTE_STEP}
              disabledHours={() => disableEndHourTableStart()}
              disabledMinutes={(date) => disableEndMinuteStart(date)}
              onChange={e => {
                let newData = datasTowClone
                const reservationAt = getFieldValue('reservationAt')
                newData[index].endAt = e ? moment(`${moment(reservationAt).format('YYYY-MM-DD')} ${moment(e).format(FORMAT)}:00`) : null
                setDatasTowClone([...newData])
              }} />
          </span>
        } else {
          return <span>{text ? moment(text).format('HH:mm') : ''}-{record.endAt ? moment(record.endAt).format('HH:mm') : ''}</span>
        }
      }
    },
    {
      dataIndex: 'roomId',
      title: '执行房间',
      width: 120,
      render: (text, record, index) => {
        if (record.editable) {
          return <Select disabled={!record.editable} style={{ width: 100 }} onChange={e => {
            let newData = datasTowClone
            let room = roomList.filter(_ => _.id === e)[0]
            newData[index].roomId = room.id
            // newData[index].roomName = room.name
            // newData[index].roomShortName = room.shortName
            newData[index].room.id = room.id
            newData[index].room.shortName = room.shortName
            setDatasTowClone([...newData])

          }} value={record.roomId}>
            {roomList && roomList.map(item => <Option value={item.id} key={item.id}>{item.shortName}</Option>)}
          </Select>
        } else {
          return <span>{record.room && record.room.shortName}</span>
        }
      }
    },
    {
      dataIndex: 'editable',
      title: '操作',
      width: 80,
      align: 'center',
      render(text, record, index) {
        return text ? <a href='javascript:void(0)' onClick={() => saveReserve(index)}>确认</a> : <a href='javascript:void(0)' disabled={disabled} onClick={() => editReserve(index)}>编辑</a>
      }
    },
  ]
  const editReserve = (index) => {
    let newData = datasTow
    newData[index].editable = true
    setDisabled(true)
    setDatasTow([...newData])
  }
  const saveReserve = (index) => {
    let newData = datasTow
    let newObj = datasTowClone[index]
    newData[index] = newObj
    newData[index].editable = false
    setDisabled(false)
    setDatasTow([...newData])
  }

  const disableEndHour = () => {
    const startTime = getFieldValue("startAt")
    if (!startTime) return []
    const hour = startTime.get("hour")
    const disabledHours = []
    for (let i = 0; i < hour; i++) {
      disabledHours.push(i)
    }
    return disabledHours
  }
  const disableEndMinute = (selectedHour) => {
    const startTime = getFieldValue("startAt")
    if (!startTime) return []
    const hour = startTime.get("hour")
    const minute = startTime.get("minute")
    if (hour > selectedHour) return MINUTE_OPTIONS
    if (hour === selectedHour) {
      return MINUTE_OPTIONS.filter(_ => _ <= minute)
    }
    return []
  }
  const disabledDate = (current) => {
    return current && current < moment().startOf('day')
  }
  const disabledDate2 = (current) => {
    return current && current > moment().subtract(0, "days")
  }

  const formTitle = (
    <div className={styles.modalHeader}>
      <div className='modal-left'>{title}</div>
      <div className='modal-right'>
        {
          (types === 'update' || getFieldValue('isComeToClinic') === true) &&
          <Button
            type='primary'
            loading={btnLoading}
            onClick={() => handleOk()}
            style={{ marginRight: 12 }}
          >
            <Icon type='save' /> 保存
          </Button>
        }
        <Button onClick={() => onCancel()}>关闭</Button>
      </div>
    </div>
  )

  // 新增一个预约填写
  const addNewReservation = () => {
    const prev = batchSetList[batchSetList.length - 1]
    const defalutItem = {
      date: prev.date ? moment(prev.date).add(1, 'week') : null,
      reservationStatus: prev.reservationStatus ? prev.reservationStatus : 'to_be_confirm',
      comment: '',
      selectedRowKeys: []
    }
    setBatchSetList([...batchSetList, defalutItem])
    setDisableRow(Object.assign(disableRow, { [batchSetList.length]: [] }))
  }
  // 更新填写的内容
  const updateArrayItem = (idx, key, value) => {
    const newArray = [...batchSetList]
    newArray[idx][key] = value
    setBatchSetList(newArray)
    if (key === 'selectedRowKeys') {
      const newDisableRow = disableRow
      newDisableRow[idx] = value
      setDisableRow(newDisableRow)
    }
  }
  // 删除当前index并扁平化
  const deleteAndFlatten = (obj, n) => {
    let newObj = cloneDeep(obj)
    delete newObj[n]
    return Object.values(newObj).flat()
  }
  const currentClinicId = getFieldValue('clinicId')
  // 如果有orderItemVos走新的批量预约 否则走原来的逻辑
  return (
    <Modal  {...modalProps} title={formTitle} className={styles.modal} onOk={(e) => handleOk(e)}>
      <Card title='预约简况' size='small' extra={nickname && <span>创建人:  {nickname}</span>}>
        <Form layout='horizontal' className={styles.orderReserveFrom}>
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label='客户' {...formItemLayout}>
                {getFieldDecorator('customerId', {
                  initialValue: data.customerId ? { customerId: data.customerId, customerName: data.customerName, clinicId: data.clinicId } : undefined,
                  rules: [
                    { required: true, message: '必填项' },
                  ],
                })(
                  <CustomerPicker onChange={e => {
                    if (!e) return
                    if (e.clinicId) {
                      setFieldsValue({ 'clinicId': e.clinicId })
                      queryMember(e.clinicId)
                    }
                    handleChangeCustomer(e.customerId, getFieldValue('clinicId'))
                  }}
                    clinicId={currentClinicId} disabled={data.customerId} />
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='预约类型' {...formItemLayout}>
                {getFieldDecorator('backTracking', {
                  initialValue: data.backTracking || false,
                })(
                  <Radio.Group
                    onChange={(e) => {
                      setFieldsValue({ reservationAt: null })
                      if (e.target.value) {
                        setFieldsValue({ status: 'arrival' })
                      } else {
                        setFieldsValue({ status: 'to_be_confirm' })
                      }
                    }}
                    disabled={types === 'update'} defaultValue={types === 'add' ? 1 : 3}>
                    <Radio key={1} value={false}>新增</Radio>
                    <Radio key={2} value={true}>补录</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label='预约门店' {...formItemLayout}>
                {getFieldDecorator('clinicId', {
                  initialValue: (data.clinicId && Number(data.clinicId)) || (clinicId && Number(clinicId)),
                  rules: [
                    { required: true, message: '必填项' },
                  ],
                })(
                  <Select disabled={clinicId || data.clinicId || (getFieldValue('customerId') && getFieldValue('customerId').clinicId)} getPopupContainer={triggerNode => triggerNode.parentNode}
                    onChange={(e) => {
                      queryMember(e)
                      if (getFieldValue('customerId')) {
                        handleChangeCustomer(getFieldValue('customerId').customerId, e)
                      }
                    }}>
                    {agencyTree && agencyTree.map((item, index) =>
                      <Option key={item.id} value={item.id}>{item.shortName}</Option>)}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          { // 编辑or到店
            (types === 'update' || getFieldValue('isComeToClinic') === true) &&
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="预约状态" {...formItemLayout}>
                  {getFieldDecorator('status', {
                    initialValue: data.status || 'to_be_confirm',
                  })(
                    <Select disabled={getFieldValue("backTracking") || data.status === 'arrival' || data.status === 'executed'} getPopupContainer={triggerNode => triggerNode.parentNode}>
                      {reserveStatus && reserveStatus.map(_ => {
                        if (data.status === 'executed') {
                          return <Option value={_.value} key={_.value}>{_.key}</Option>
                        } else {
                          if ((types === 'add' && _.key === '取消') || _.key === '已执行') {
                            return
                          } else {
                            if (data.cancelAble) {
                              return <Option disabled={types === 'add' && _.key === '取消'} value={_.value} key={_.value}>{_.key}</Option>
                            } else {
                              if (_.key === '取消') {
                                return
                              } else if (_.key === '待确认' && types !== 'add') {
                                return <Option disabled={types === 'add' && _.key === '取消'} value={_.value} key={_.value}>{_.key}</Option>
                              } else {
                                return <Option disabled={types === 'add' && _.key === '取消'} value={_.value} key={_.value}>{_.key}</Option>
                              }
                            }
                          }
                        }
                      })}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="预约到店日期" {...formItemLayout}>
                  {getFieldDecorator('reservationAt', {
                    initialValue: data.reservationAt ? moment(data.reservationAt) : null,
                    rules: [
                      { required: true, message: '请选择预约日期' },
                    ],
                  })(
                    <DatePicker showToday={getFieldValue("backTracking")} getPopupContainer={triggerNode => triggerNode.parentNode} disabledDate={getFieldValue("backTracking") ? disabledDate2 : disabledDate} />
                  )}
                </Form.Item>
              </Col>
            </Row>
          }
          {
            (types === 'update' || getFieldValue('isComeToClinic') === true) &&
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="开始时间" {...formItemLayout}>
                  {getFieldDecorator('startAt', {
                    initialValue: data.startAt ? moment(data.startAt) : null,
                  })(
                    <TimePicker
                      getPopupContainer={triggerNode => triggerNode.parentNode}
                      format={FORMAT}
                      minuteStep={MINUTE_STEP}
                      defaultOpenValue={moment('09:00', 'HH:mm')}
                      onChange={(e) => {
                        if ((getFieldValue('endAt') && moment(e) < getFieldValue('endAt')) || !e) {
                          //如果没有预约过 去赋值
                          if (overReservation.length < 1 && e) {
                            let temp = orderItemVos;
                            temp && temp.length > 0 && temp.forEach((item) => {
                              item.startAt = moment(e);
                            })
                            setOrderItemVos([...temp]);
                          }
                          return -1
                        } else {
                          setFieldsValue({ endAt: moment(e).add(1, 'h') })
                          //如果没有预约过 去赋值
                          if (overReservation.length < 1 && e) {
                            let temp = orderItemVos;
                            let selectedTemp = reservationItems;
                            temp && temp.length > 0 && temp.forEach((item) => {
                              item.startAt = moment(e);
                              item.endAt = moment(e).add(1, 'h')
                            })
                            selectedTemp && selectedTemp.length > 0 && selectedTemp.forEach((item) => {
                              item.startAt = moment(e);
                              item.endAt = moment(e).add(1, 'h');
                            })
                            setOrderItemVos([...temp]);
                            setReservationItems([...selectedTemp]);
                          }
                        }
                      }}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="结束时间" {...formItemLayout}>
                  {getFieldDecorator('endAt', {
                    initialValue: data.endAt ? moment(data.endAt) : null,
                  })(
                    <TimePicker
                      getPopupContainer={triggerNode => triggerNode.parentNode}
                      format={FORMAT}
                      defaultOpenValue={moment('09:00', 'HH:mm')}
                      minuteStep={MINUTE_STEP}
                      disabledHours={() => disableEndHour()}
                      disabledMinutes={(date) => disableEndMinute(date)}
                      onChange={(e) => {
                        if (e) {
                          if (overReservation.length < 1) {
                            let temp = orderItemVos;
                            let selectedTemp = reservationItems;
                            temp && temp.length > 0 && temp.forEach((item) => {
                              item.endAt = moment(e)
                            })
                            selectedTemp && selectedTemp.length > 0 && selectedTemp.forEach((item) => {
                              item.endAt = moment(e);
                            })
                            setOrderItemVos([...temp]);
                            setReservationItems([...selectedTemp]);
                          }
                        }
                      }}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
          }
          <Row gutter={16}>
            {
              source !== 'ORDER' && orderItemVos.length > 0 &&
              <Col span={12}>
                <Form.Item label='仅预约到店' {...formItemLayout} valuePropName='checked'>
                  {getFieldDecorator('isComeToClinic', {})(
                    <Switch size='small' defaultChecked={data.isComeToClinic} />
                  )}
                </Form.Item>
              </Col>
            }
            {
              (getFieldValue('status') === 'arrival' || getFieldValue('status') === 'executed') &&
              <Col span={12}>
                <Form.Item label='到店日期' {...formItemLayout}>
                  {getFieldDecorator('arrivedAt', {
                    initialValue: getFieldValue('reservationAt'),
                    rules: [
                      { required: true, message: '请选择到店日期' },
                    ],
                  })(
                    <DatePicker showToday={true} getPopupContainer={triggerNode => triggerNode.parentNode} disabledDate={disabledDate2} />
                  )}
                </Form.Item>
              </Col>
            }
          </Row>
          {
            (types === 'update' || getFieldValue('isComeToClinic') === true) &&
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item label="备注" labelCol={{ span: 3 }} wrapperCol={{ span: 18 }}>
                  {getFieldDecorator('comment', {
                    initialValue: data.comment,
                  })(
                    <TextArea maxLength={500} autoSize={{ minRows: 3, maxRows: 8 }} />
                  )}
                </Form.Item>
              </Col>
            </Row>
          }
        </Form>
      </Card>
      {
        (source === 'ORDER' || (!getFieldValue('isComeToClinic') && orderItemVos.length > 0)) &&
        <Card title='预约明细' className={source !== 'ORDER' ? styles.hideSelect : ''} size='small' style={{ marginTop: 20 }}>
          <Tabs defaultActiveKey='1' size='small'>
            {
              types === 'update' && source === 'ORDER' &&
              <TabPane tab='当前预约' key='1'>
                <Table scroll={{ y: 230 }} columns={columns2} dataSource={datasTow} size='small' pagination={false} />
              </TabPane>
            }
            {
              types === 'add' &&
              <TabPane tab='待预约' key='2'>
                {
                  batchSetList && batchSetList.map((it, index) => {
                    const newDisableRow = deleteAndFlatten(disableRow, index)
                    const neworderItemVos = cloneDeep(orderItemVos)
                    const newData = neworderItemVos.filter(i => !newDisableRow.includes(i.id))
                    return <Spin indicator={null} spinning={!!it.spinning} tip='当前已保存'>
                      <Card
                        title={
                          <Row gutter={24}>
                            <Col span={4}><span style={{ fontSize: 16 }}>{`第${index + 1}个预约明细`}</span></Col>
                            <Col span={6}>
                              <span style={{ color: 'red' }}>*</span>预约日期: <DatePicker showToday value={it.date} onChange={date => updateArrayItem(index, 'date', date)} />
                            </Col>
                            <Col span={4}>
                              预约状态: <Select style={{ width: 120 }} value={it.reservationStatus} onChange={val => updateArrayItem(index, 'reservationStatus', val)}>
                                {reserveStatus && reserveStatus.map(_ => {
                                  return <Option value={_.value} key={_.value}>{_.key}</Option>
                                })}
                              </Select>
                            </Col>
                            <Col span={6}>
                              备注: <Input style={{ width: 200 }} value={it.comment} onChange={e => updateArrayItem(index, 'comment', e.target.value)} />
                            </Col>
                            <Col span={4}>
                              <Button type='primary' onClick={() => handleBatchAddReserve(index)}>保存预约</Button>
                            </Col>
                          </Row>
                        }
                      >
                        <Table
                          className={styles.tableReserve}
                          columns={columns(index)}
                          dataSource={newData || []}
                          pagination={false}
                          size='small'
                          rowKey='id'
                          rowSelection={{
                            selectedRowKeys: it.selectedRowKeys,
                            onChange: (selectedRowKeys) => updateArrayItem(index, 'selectedRowKeys', selectedRowKeys),
                          }}
                          // onExpandedRowsChange={(expanded) => {
                          //   console.log('ddddd', expanded)
                          // }}
                          // onExpand={(expanded, record) => {
                          //   console.log('kkkk', expanded, record)
                          // }}
                          // defaultExpandAllRows
                          expandedRowKeys={expandedKeys}
                          expandIcon={() => { return '' }}
                          expandedRowRender={(record) => record.reservedTimesString && <div style={{ textAlign: 'center', padding: 8 }}>咨询师当天以下时间已预约（不限于当前门店）{record.reservedTimesString}</div>}
                        />
                      </Card>
                    </Spin>
                  })
                }
                {batchSetList && <Button icon='plus' type='primary' onClick={addNewReservation}>新增一个预约</Button>}
              </TabPane>
            }
          </Tabs>
        </Card>
      }
    </Modal >
  )
}

export default Form.create()(OrderReserveModal)
